// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"78":"8e004523","227":"2d2d8c18","726":"f837ecf9","854":"3f30ccb1"}[chunkId] + ".chunk.css");